module.exports = __webpack_public_path__ + "static/pic02-f8d8946098770a4ccd98a5f36398fba9.jpg";